/// <amd-module name="Artifacts/Package/components/package-details-common/PackageTile" />
import * as React from "react";
import { Card } from "VSSUI/Card";
import { css } from "VSSUI/Util";

export interface IPackageTileProps {
  title?: string;
  className?: string;
}

export class PackageTile extends React.PureComponent<IPackageTileProps> {
  public render(): JSX.Element {
    return (
      <div className="package-tile-container">
        <Card
          className={css("package-tile", this.props.className)}
          titleProps={{
            className: "package-tile-title",
            text: this.props.title,
            ariaLevel: 2,
          }}
        >
          <div className="package-tile-content">{this.props.children}</div>
        </Card>
      </div>
    );
  }
}
